import { combineReducers } from '@reduxjs/toolkit';
import { metadataReducer } from '../common/metadata.slice';
import { dashboardV2Reducer } from '../features/dashboard/slices/dashboardV2Slice';
import {
  filterReducer,
  taskViewReducer,
} from '../features/dashboard/slices/statusSlice';
import { autoEvidenceReducer } from '../features/detail/autoEvidence/automatedEvidenceSlice';
import { decisionReducer } from '../features/detail/decision/decisionSlice';
import { detailReducer } from '../features/detail/detailSlice';
import { codebackReducer } from '../features/detail/drawer/codeback/CodebackSlice';
import { drawerCoordReducer } from '../features/detail/drawer/drawerCoordSlice';
import { notesDraftReducer } from '../features/detail/notes/notesDraftSlice';
import { notesReducer } from '../features/detail/notes/notesSlice';
import { piaInfoReducer } from '../features/detail/pia/piaSlice';
import { policyStatusReducer } from '../features/detail/policyStatus/policyStatusSlice';
import { erroredTaskListReducer } from '../features/taskErrorsDashboard/erroredTaskListSlice';
import { summaryResponseReducer } from '../features/tasks/slice/aiSummaryListSlice';
import { taskListReducer } from '../features/tasks/slice/taskListSlice';
import { taskUiReducer } from '../features/tasks/slice/taskUiSlice';

const combinedReducers = combineReducers({
  filters: filterReducer,
  taskView: taskViewReducer,
  /**
   * Note that application, decision, notes, task, etc., here are temporal and map
   * to the particular Detail view we're hitting (so these will get clobbered).
   * If/when we need longer-term state, we'll store that in the plural counterpart
   * keys e.g. `applications: [], decisions: { [APP_ID]: <decision>, ...} or whatever.
   */
  application: detailReducer,
  decision: decisionReducer,
  notes: notesReducer,
  notesDraft: notesDraftReducer,
  piaInfo: piaInfoReducer,
  taskList: taskListReducer,
  summaryResponseReducer,
  taskUi: taskUiReducer,
  automatedEvidence: autoEvidenceReducer,
  erroredTaskList: erroredTaskListReducer,
  policyStatus: policyStatusReducer,
  metadata: metadataReducer,
  codeback: codebackReducer,
  drawerCoord: drawerCoordReducer,
  dashboardV2: dashboardV2Reducer,
});

const rootReducer = (state: any, action: any) => {
  // Log all actions that change the state of Nora application.
  console.log(action.type, {
    termPolicyId: state?.application?.termPolicyId,
  });

  return combinedReducers(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
